import { ApplicantCall } from './requirements/ApplicantCall/ApplicantCall';
import { BankDetails } from './requirements/BankDetails/BankDetails';
import { CreditAgreement } from './requirements/CreditAgreement/CreditAgreement';
import { IdVerification } from './requirements/IdVerification/IdVerification';
import { PersonalGuarantee } from './requirements/PersonalGuarantee/PersonalGuarantee';
import { UploadBankEvidence } from './requirements/UploadBankEvidence/UploadBankEvidence';
import { UploadGewerbeschein } from './requirements/UploadGewerbeschein/UploadGewerbeschein';
import { useGetFundingRequirements } from '../../hooks/useGetFundingRequirements';

export const RequirementsList = () => {
    const { requirements } = useGetFundingRequirements();

    return (
        <div
            data-testid="requirements-list"
            className="border-t border-secondary-90"
        >
            {requirements.map((requirement) => {
                switch (requirement.type) {
                    case 'bank_details':
                        return (
                            <BankDetails
                                key={requirement.type}
                                {...requirement}
                            />
                        );
                    case 'id_verification':
                        return (
                            <IdVerification
                                key={requirement.type}
                                {...requirement}
                            />
                        );
                    case 'upload_gewerbeschein':
                        return (
                            <UploadGewerbeschein
                                key={requirement.type}
                                {...requirement}
                            />
                        );
                    case 'credit_agreement':
                        return (
                            <CreditAgreement
                                key={requirement.type}
                                {...requirement}
                            />
                        );
                    case 'personal_guarantee':
                        return (
                            <PersonalGuarantee
                                key={requirement.type}
                                {...requirement}
                            />
                        );
                    case 'upload_bank_evidence':
                        return (
                            <UploadBankEvidence
                                key={requirement.type}
                                {...requirement}
                            />
                        );
                    case 'applicant_call':
                        return (
                            <ApplicantCall
                                key={requirement.type}
                                {...requirement}
                            />
                        );
                }
            })}
        </div>
    );
};
